/** Unauthenticated portal routes that should use system appearance, not saved theme. */
const PORTAL_AUTH_ROUTE_PREFIXES = [
	'/login',
	'/aria/login',
	'/login-by-token',
	'/password-forget',
	'/reset-forget-password',
	'/auto-login',
] as const;

export function isPortalAuthRoute(pathname: string): boolean {
	return PORTAL_AUTH_ROUTE_PREFIXES.some(
		(prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`),
	);
}
